import React, { useEffect, useState } from 'react';
import AdminWrapper from '../../components/common/AdminWrapper';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
// import FacilityModal from '../../components/modals/FacilityModal';

export default () => {
  const [facilities, setFacilities] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteKey, setDeleteKey] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [control, setControl] = useState('Add');
  const [facilityData, setFacilityData] = useState({});
  const [lastKey, setLastKey] = useState('');
  const [fetchingMore, setFetchingMore] = useState(false);
  const [perPage, setPerPage] = useState(10);

  const onSearch = (val) => {
    setQuery(val);
    let text = val.toLowerCase();
    document.querySelectorAll('#search-item').forEach((dataRow) => {
      const name = dataRow.childNodes[1].textContent;
      if (name.toLowerCase().indexOf(text) !== -1) {
        dataRow.style.display = 'table-row';
      } else {
        dataRow.style.display = 'none';
      }
    });
  };

  const getFacilities = (data) => {
    // setLoading(true);
    // db.ref('facility/')
    //   .limitToFirst(data ? data : perPage)
    //   .once('value')
    //   .then((snapshot) => {
    //     const dataObject = [];
    //     const dataItems = [];
    //     const data = snapshot.val() ? snapshot.val() : {};
    //     const keyEntries = Object.keys(data);
    //     const dataEntries = Object.entries(data);
    //     dataEntries.forEach((data) => {
    //       data.forEach((item) => {
    //         if (typeof item == 'object') {
    //           dataItems.push(item);
    //         }
    //       });
    //     });
    //     keyEntries.forEach((keyItem, index) => {
    //       let newData = dataItems[index];
    //       newData.key = keyItem;
    //       dataObject.push(newData);
    //     });
    //     const lasktKey = dataObject[dataObject.length - 1];
    //     setLastKey(lasktKey.key);
    //     setFacilities(dataObject);
    //   })
    //   .catch((err) => toast.error('Something went wrong!'))
    //   .finally(() => setLoading(false));
  };

  const getMore = () => {
    // setFetchingMore(true);
    // db.ref('facility/')
    //   .orderByKey()
    //   .limitToFirst(perPage)
    //   .startAt(lastKey)
    //   .once('value')
    //   .then((snapshot) => {
    //     const dataObject = [];
    //     const dataItems = [];
    //     const data = snapshot.val() ? snapshot.val() : {};
    //     const keyEntries = Object.keys(data);
    //     const dataEntries = Object.entries(data);
    //     let last = keyEntries.slice(-1)[0];
    //     dataEntries.forEach((data) => {
    //       data.forEach((item) => {
    //         if (typeof item == 'object') {
    //           dataItems.push(item);
    //         }
    //       });
    //     });
    //     keyEntries.forEach((keyItem, index) => {
    //       let newData = dataItems[index];
    //       newData.key = keyItem;
    //       dataObject.push(newData);
    //     });
    //     dataObject.shift();
    //     const newDataItems = [...facilities, ...dataObject];
    //     setLastKey(last);
    //     setFacilities(newDataItems);
    //   })
    //   .catch((err) => toast.error('Something went wrong!'))
    //   .finally(() => setFetchingMore(false));
  };

  const refreshPaginatedData = (data) => {
    setPerPage(data);
    getFacilities(data);
  };

  const getWithoutLoading = () => {
    // db.ref('facility/')
    //   .limitToFirst(perPage)
    //   .once('value')
    //   .then((snapshot) => {
    //     const dataObject = [];
    //     const dataItems = [];
    //     const data = snapshot.val() ? snapshot.val() : {};
    //     const keyEntries = Object.keys(data);
    //     const dataEntries = Object.entries(data);
    //     dataEntries.forEach((data) => {
    //       data.forEach((item) => {
    //         if (typeof item == 'object') {
    //           dataItems.push(item);
    //         }
    //       });
    //     });
    //     keyEntries.forEach((keyItem, index) => {
    //       let newData = dataItems[index];
    //       newData.key = keyItem;
    //       dataObject.push(newData);
    //     });
    //     const lasktKey = dataObject[dataObject.length - 1];
    //     setLastKey(lasktKey.key);
    //     setFacilities(dataObject);
    //   })
    //   .catch((err) => toast.error('Something went wrong!'));
  };

  const confirmDelete = (data) => {
    confirmAlert({
      title: 'Confirm to delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => deleteFacility(data),
        },
        {
          label: 'No',
          onClick: () => {},
        },
      ],
    });
  };

  const deleteFacility = (data) => {
    // setDeleting(true);
    // setDeleteKey(data.key);
    // db.ref(`/facility/${data.key}`)
    //   .update({ isDelete: true })
    //   .then(() => {
    //     setDeleteKey('');
    //     getWithoutLoading();
    //     toast.success('Category information deleted!');
    //   })
    //   .catch((err) => toast.error('Something went wrong'))
    //   .finally(() => setDeleting(false));
  };

  const removeDelete = (data) => {
    // setDeleting(true);
    // setDeleteKey(data.key);
    // db.ref(`/facility/${data.key}`)
    //   .update({ isDelete: false })
    //   .then(() => {
    //     setDeleteKey('');
    //     getWithoutLoading();
    //     toast.success('Category information restored!');
    //   })
    //   .catch((err) => toast.error('Something went wrong'))
    //   .finally(() => setDeleting(false));
  };

  const setEdit = (data) => {
    setFacilityData(data);
    setControl('Edit');
    setIsOpen(true);
  };

  useEffect(() => {
    getFacilities();
  }, []);

  let container;

  if (loading) {
    container = (
      <>
        <tr>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
          <td>
            <Skeleton width={80} />
          </td>
        </tr>
      </>
    );
  } else {
    if (Object.keys(facilities).length > 0) {
      container = facilities.map((item, index) => (
        <tr key={item.key} id="search-item">
          <td>{index + 1}</td>
          <td>{item.name}</td>
          <td>
            {item.isDelete ? (
              <span className="badge badge-pill iq-bg-danger">
                Deleted
              </span>
            ) : (
              <span className="badge badge-pill iq-bg-success">
                Active
              </span>
            )}
          </td>
          <td>
            <i
              className="ri-ball-pen-fill text-success pr-1 action-badge-size"
              onClick={() => setEdit(item)}
            ></i>
            {deleteKey == item.key && deleting ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              <>
                {item.isDelete ? (
                  <span onClick={() => removeDelete(item)}>
                    <span
                      className="iconify text-secondary action-badge-size"
                      data-icon="ic:twotone-settings-backup-restore"
                      data-inline="false"
                    ></span>
                  </span>
                ) : (
                  <i
                    className="ri-delete-bin-5-line text-danger action-badge-size"
                    onClick={() => confirmDelete(item)}
                  ></i>
                )}
              </>
            )}
          </td>
        </tr>
      ));
    } else {
      container = (
        <tr>
          <td></td>
          <td>No information at the moment</td>
          <td></td>
        </tr>
      );
    }
  }

  return (
    <AdminWrapper>
      <div className="iq-card">
        <div className="iq-card-header d-flex justify-content-between">
          <div className="iq-header-title">
            <h4 className="card-title">Free Facilities</h4>
          </div>
        </div>
        <div className="iq-card-body">
          <div className="row mb-3">
            <div className="col-2 mr-auto">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setIsOpen(true);
                  setFacilityData({});
                }}
              >
                Add facility
              </button>
            </div>
            <div className="col-5"></div>
            <div className="col-2">
              <select
                defaultValue={perPage}
                className="form-control pagination-dropdown"
                onChange={(e) =>
                  refreshPaginatedData(parseInt(e.target.value))
                }
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className="col-3 ml-auto">
              <input
                className="form-control"
                defaultValue={query}
                type="text"
                placeholder="Search facilities..."
                onChange={(e) => onSearch(e.target.value)}
              />
            </div>
          </div>
          <table className="table table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {container}
              {fetchingMore && (
                <tr>
                  <td>
                    <Skeleton width={80} />
                  </td>
                  <td>
                    <Skeleton width={80} />
                  </td>
                  <td>
                    <Skeleton width={80} />
                  </td>
                  <td>
                    <Skeleton width={80} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* <FacilityModal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        facilityData={facilityData}
        control={control}
        fetchFacilities={getWithoutLoading}
      /> */}
    </AdminWrapper>
  );
};
